import React, { Component } from 'react';
import { connect } from 'react-redux';
import DevicesSearch from 'containers/Devices/DevicesSearch';
import DeviceList from 'containers/Devices/DeviceList';
import { clearDeviceList } from 'actions/devices';
import { clearModel } from 'actions/model';
import { isMatchURL } from 'helpers/StringHelper';

class Devices extends Component {
  componentWillUnmount() {
    // clean only if tab was changed completely
    if (!isMatchURL('devices')) {
      this.props.clearDeviceList();
      this.props.clearModel();
    }
  }

  render() {
    return (
      <div>
        <h1>Certified Devices</h1>
        <DevicesSearch history={this.props.history} />
        <DeviceList />
      </div>
    );
  }
}

export default connect(
  null,
  { clearDeviceList, clearModel }
)(Devices);



// WEBPACK FOOTER //
// ./src/containers/Devices/index.js